<section class="error__content">
  <app-image
    class="error__image"
    src="assets/icon/warning.svg"
    [alt]="'ALT_IMG.HELP' | translate"
  ></app-image>
  <h3 class="error__title">
    {{ getTitle() | translate }}
  </h3>
  @if (workplaceMissing) {
    <p class="error__text error__text--margin">
      {{ 'REGISTER_TIME.MODAL_ERROR.P4' | translate }}
    </p>
  }
  @if (presentialTimeExceeded) {
    <p
      class="error__text error__text--margin"
      [innerHTML]="'REGISTER_TIME.MODAL_ERROR.P5' | translate"
    ></p>
  }

  @if (!distributedTime && !errorMessage) {
    <p class="error__text error__text--margin">
      {{ getMainMessageError() | translate }}
    </p>
  }

  @if (!distributedTime && !errorMessage) {
    <p class="error__text">
      {{ 'REGISTER_TIME.MODAL_ERROR.P2' | translate }}
    </p>
  }

  @if (errorMessage) {
    <p class="error__text">{{ errorMessage | translate }}</p>
  }

  <div class="error__buttons">
    <ion-button class="error__button" (click)="dismissModal()">
      {{ 'REGISTER_TIME.MODAL_ERROR.OK' | translate }}
    </ion-button>
  </div>
</section>
